import { z } from "zod";
import { BillExtractionRecordSchema } from "@common/schemas/financialDocument/bill-extraction-record.schema";
import { InvoiceExtractionRecordSchema } from "@common/schemas/financialDocument/invoice-extraction-record.schema";

function assertUniqueAccrualExtractionRecordIds(
    extractions: Array<{
        id: string;
        lineItems: Array<{ lineId: string }>;
    }>,
    ctx: z.RefinementCtx,
): void {
    const extractionIds = new Set<string>();

    for (const [extractionIndex, extraction] of extractions.entries()) {
        if (extractionIds.has(extraction.id)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Duplicate extraction id in request",
                path: [extractionIndex, "id"],
            });
        }
        extractionIds.add(extraction.id);

        const lineItemIds = new Set<string>();
        for (const [
            lineItemIndex,
            lineItem,
        ] of extraction.lineItems.entries()) {
            if (lineItemIds.has(lineItem.lineId)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Duplicate line item id in request",
                    path: [
                        extractionIndex,
                        "lineItems",
                        lineItemIndex,
                        "lineId",
                    ],
                });
            }
            lineItemIds.add(lineItem.lineId);
        }
    }
}

export const UniqueInvoiceExtractionRecordsSchema = z
    .array(InvoiceExtractionRecordSchema)
    .max(50)
    .superRefine(assertUniqueAccrualExtractionRecordIds);

export const UniqueBillExtractionRecordsSchema = z
    .array(BillExtractionRecordSchema)
    .max(50)
    .superRefine(assertUniqueAccrualExtractionRecordIds);
